import skeletonHtml from './skeleton.html?raw';

export const template = skeletonHtml;

export class viewModel {
}
